import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { Buffer as BufferPolyfill } from 'buffer'

// Polyfill global for WalletConnect
if (!window.global) {
  window.global = window;
}
if (!window.Buffer) {
  window.Buffer = BufferPolyfill;
}
if (!window.process) {
  window.process = { env: {} } as any;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
